import { useEffect, useRef, useState } from "react";
import { Box, Skeleton, Typography } from "@mui/material";
import { GanttSection } from "@/pages/home/components/gantt-section";

interface Props {
	shiftStart: Date | null;
	shiftEnd: Date | null;
	onError?: (e: Error) => void;
	loading?: boolean;
}

export const ShiftGantt = ({
	shiftStart,
	shiftEnd,
	onError,
	loading,
}: Props) => {
	const [width, setWidth] = useState(0);
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (!containerRef.current) return;
		const observer = new ResizeObserver((entries) => {
			for (const entry of entries) {
				setWidth(entry.contentRect.width);
			}
		});
		observer.observe(containerRef.current);
		return () => observer.disconnect();
	}, []);

	return (
		<Box ref={containerRef} sx={{ width: "100%" }}>
			{loading ? (
				<Skeleton variant="rounded" width="100%" height={110} />
			) : !shiftStart || !shiftEnd ? (
				<Typography variant="body2" color="text.secondary">
					No active shift to display.
				</Typography>
			) : (
				<GanttSection
					startDate={shiftStart}
					endDate={shiftEnd}
					viewMode="Bundles"
					containerWidth={width}
					onError={onError}
				/>
			)}
		</Box>
	);
};
